import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getWeeksOptions } from '../../../redux/slices/customer/trainingSlice';

const WeeksModal = ({
  isOpen,
  onClose,
  setSelectedWeek,
  selectedWeek
}) => {
  const dispatch = useDispatch();
  const { weeks_options } = useSelector((state) => state.customer_training);  

  useEffect(() => {
    if (isOpen) {
      dispatch(getWeeksOptions());
    }
  }, [isOpen, dispatch]);

  const sortedWeeksOptions = weeks_options?.slice().sort((a, b) => a.weeks - b.weeks) || [];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedWeek) {
      alert("Please select a week.");
      return;
    }
    alert(`You selected ${selectedWeek} week(s).`);
    onClose();
  };

  return isOpen ? (
    <div
      className="modal fade show replace-exercise-modal"
      style={{ display: "block" }}
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h6 className="modal-title">How Many Days Per Week Do You Want To Train?</h6>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="w-100 mt-4">
                <label className="inputLabel mb-2" htmlFor="weeks-select">
                  Select number of days
                </label>
                <select
                  id="weeks-select"
                  className="form-control"
                  value={selectedWeek}
                  onChange={(e) => setSelectedWeek(e.target.value)}
                  required
                >
                  <option value="All">Any</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                </select>
              </div>
              <div className="form-group mb-0 mt-4">
                <button
                  type="submit"
                  className="btn-curve w-100"
                >
                  Search Programs
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default WeeksModal;
